import clButton from "./clButton";
import clInput from "./clInput";
import clRadio from "./clRadio";
import clCheckbox from "./clCheckbox";
import pickerColumn from "./pickerColumn";
import picker from "./picker";
import clSelect from "./clSelect";
import clLabel from "./clLabel";
import clForm from "./clForm";

const install = function(Vue) {
    Vue.component("clButton", clButton);
    Vue.component("clInput", clInput);
    Vue.component("clRadio", clRadio);
    Vue.component("clCheckbox", clCheckbox);
    Vue.component("pickerColumn", pickerColumn);
    Vue.component("picker", picker);
    Vue.component("clSelect", clSelect);
    Vue.component("clLabel", clLabel);
    Vue.component("clForm", clForm);
};

export default install
